module.exports = __webpack_public_path__ + "static/media/flask.b2381f8a.png";